import { store } from '../../store';
import {
  addLabRequest,
  updateLabRequest,
  deleteLabRequest
} from '../../ReduxSlices/LabRequests/labRequests';
import subscribeToCoreUpdates from '../core_updates_channel';

let unsubscribeLabRequests = null; // store unsubscribe function

export const initializeLabRequestSubscription = () => {
  if (unsubscribeLabRequests) return; // already subscribed

  // Use a unique module key "labRequests"
  unsubscribeLabRequests = subscribeToCoreUpdates("labRequests", {
    "lab_request.created": (data) => {
      store.dispatch(addLabRequest(data));
    },
    "lab_request.updated": (data) => {
      store.dispatch(updateLabRequest(data));
    },
    "lab_request.deleted": (data) => {
      store.dispatch(deleteLabRequest(data.id));
    }
  });

  // console.log("✅ Lab Requests subscription initialized");
};

export const unsubscribeLabRequestSubscription = () => {
  if (unsubscribeLabRequests) {
    unsubscribeLabRequests(); // remove only labRequests handlers
    unsubscribeLabRequests = null;
    // console.log("🔌 Lab Requests subscription removed");
  }
};